import { createBrowserRouter, createRoutesFromElements, Route, Navigate, Outlet } from 'react-router-dom';

import { MainLayout } from './layouts';
import { InvoiceGeneratorPage, AccessDeniedPage } from '@pages/index';

import { APP_ROUTES } from '@shared/lib';
import { selectIsAuth } from '@entities/user';
import { useAppSelector } from '@shared/model';

export const AppRouter = createBrowserRouter(
  createRoutesFromElements(
    <Route path={APP_ROUTES.base} element={<MainLayout />}>
      <Route path="*" element={<Navigate to={APP_ROUTES.generator.employees} />} />
      <Route element={<AuthGuard />}>
        <Route path={APP_ROUTES.generator.employees}>
          <Route index element={<InvoiceGeneratorPage />} />
        </Route>
      </Route>

      <Route element={<GuestGuard />}>
        <Route path={APP_ROUTES.base} element={<AccessDeniedPage />} />
      </Route>
    </Route>
  )
);

function AuthGuard() {
  const isAuthorized = useAppSelector(selectIsAuth);

  if (!isAuthorized) {
    return <Navigate to={APP_ROUTES.base} />;
  }

  return <Outlet />;
}

function GuestGuard() {
  const isAuthorized = useAppSelector(selectIsAuth);

  if (isAuthorized) {
    return <Navigate to={APP_ROUTES.generator.employees} />;
  }

  return <Outlet />;
}
